import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"

export function AppFooter() {
  const { t } = useTranslation('common')
  const currentYear = new Date().getFullYear()

  return (
    <footer className="border-t border-slate-800 bg-slate-900 mt-auto">
      <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
          {/* Left side - Brand */}
          <div className="flex items-center gap-2">
            <div className="flex h-6 w-6 items-center justify-center rounded-md bg-gradient-to-br from-primary to-primary/70 shadow-sm shadow-primary/25">
              <span className="text-xs font-bold text-white">P</span>
            </div>
            <span className="text-sm font-medium text-slate-400">
              © {currentYear} Prosigliere
            </span>
          </div>

          {/* Center - Links */}
          <nav className="flex items-center gap-6">
            <Link
              to="/dashboard"
              className="text-sm text-slate-400 transition-colors hover:text-white"
            >
              {t('nav.dashboard')}
            </Link>
            <Link
              to="/invoices"
              className="text-sm text-slate-400 transition-colors hover:text-white"
            >
              {t('nav.invoices')}
            </Link>
            <a
              href="mailto:support@prosigliere.com"
              className="text-sm text-slate-400 transition-colors hover:text-white"
            >
              {t('nav.support')}
            </a>
          </nav>

          {/* Right side - Additional info */}
          <div className="text-sm text-slate-400">
            {t('footer.madeWith')}{" "}
            <span className="text-red-500" aria-label="love">
              ♥
            </span>{" "}
            {t('footer.tagline')}
          </div>
        </div>
      </div>
    </footer>
  )
}
